// 本地存储工具方法，封装对 window.localStorage 的增删改查操作

/**
 * 保存数据（新增 / 覆盖）
 * 会自动对对象进行 JSON 序列化
 * @param {string} key
 * @param {any} value
 */
export function setItem(key, value) {
  if (typeof window === 'undefined' || !window.localStorage) return;

  try {
    const stringValue =
      typeof value === 'string' ? value : JSON.stringify(value);
    window.localStorage.setItem(key, stringValue);
  } catch (error) {
    console.error('[localStorageUtil.setItem] 保存失败:', error);
  }
}

/**
 * 读取数据
 * 默认会尝试 JSON.parse，如果失败则返回原始字符串
 * @param {string} key
 * @param {any} defaultValue 读取失败或不存在时返回的默认值
 * @returns {any}
 */
export function getItem(key, defaultValue = null) {
  if (typeof window === 'undefined' || !window.localStorage) return defaultValue;

  try {
    const value = window.localStorage.getItem(key);
    if (value === null || value === undefined) return defaultValue;

    // 尝试按 JSON 解析
    try {
      return JSON.parse(value);
    } catch {
      // 不是 JSON，就按原始字符串返回
      return value;
    }
  } catch (error) {
    console.error('[localStorageUtil.getItem] 读取失败:', error);
    return defaultValue;
  }
}

/**
 * 更新数据（适用于存储对象时的局部更新）
 * 会先读取原来的对象，与传入的 partial 对象做浅合并后再写回
 * @param {string} key
 * @param {object} partial
 */
export function updateItem(key, partial) {
  if (typeof window === 'undefined' || !window.localStorage) return;

  try {
    const current = getItem(key, {});
    if (current && typeof current === 'object' && !Array.isArray(current)) {
      const next = { ...current, ...partial };
      setItem(key, next);
    } else {
      // 如果原来不是对象，直接覆盖为 partial
      setItem(key, partial);
    }
  } catch (error) {
    console.error('[localStorageUtil.updateItem] 更新失败:', error);
  }
}

/**
 * 删除指定 key
 * @param {string} key
 */
export function removeItem(key) {
  if (typeof window === 'undefined' || !window.localStorage) return;

  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.error('[localStorageUtil.removeItem] 删除失败:', error);
  }
}

/**
 * 清空所有本地存储（慎用）
 */
export function clearAll() {
  if (typeof window === 'undefined' || !window.localStorage) return;

  try {
    window.localStorage.clear();
  } catch (error) {
    console.error('[localStorageUtil.clearAll] 清空失败:', error);
  }
}

/**
 * 获取localStorage数据的别名方法
 * @param {string} key
 * @param {any} defaultValue
 * @returns {any}
 */
export function getLocalStorage(key, defaultValue = null) {
  return getItem(key, defaultValue);
}

